function getServerApiUrl() {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:8080/api";
    // return "https://api.nuancebro.com/api";
  }
  return "https://api.nuancebro.com/api";
}

export const SERVER_API_URL = getServerApiUrl();
